module.exports = __webpack_public_path__ + "img/approval.ef689589.svg";